<template>
    <div>
        <v-layout wrap row justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
                <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Manual del fabricante</h1>
                <p class="animated fadeIn dura-2">
                    El personal que desarrollará el monitoreo independiente de la realización del curso, deberá realizar
                    una lectura completa del manual de operación de los equipos, con el fin de identificar todos los
                    usos y aplicaciones de los instrumentos a utilizar.
                </p>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center pantalla">
                <img class="animated flipInY dura-3" :src="require('../../assets/unidad2/pantalla-3-1-10.png')" height="370" alt="" />
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import nextConditions from "../../js/mixins/nextConditions";
import svgmod from "./svg/mod4"

export default {
    components: {
        svgmod,
    },
    mixins: [nextConditions],
    data() {
        return {}
    },
    mounted() {
        this.$store.commit('vistosUnidad1Mod31', false)
        this.$store.commit('vistosUnidad1Mod32', false)
        this.$store.commit('vistosUnidad1Mod33', false)
        this.$store.commit('vistosUnidad1Mod34', false)
        this.$store.commit('vistosAllMod3', false)
        setTimeout(() => {
            this.$store.commit('nextShow', true)
        }, 3000);
    },
}
</script>

<style lang="scss" scoped>
@import '../../sass/globals';

.icon-titulo {
    content: url('../../assets/imagenes_compartidas/icon-titulo.png');
    align-items: center;
    justify-content: start;
    width: 15px;
    height: 15px;
}

ol {
    list-style: none;
    counter-reset: my-awesome-counter;
    padding-left: 10px;
}

ol li {
    counter-increment: my-awesome-counter;
    display: flex;
    align-items: center;
    justify-content: start;

    span {
        margin: 0.5em;
        padding: 0.5em;
        border-left: 2px solid $color-complement-one;
    }
}

ol li::before {
    content: counter(my-awesome-counter) ". ";
    color: $color-primary;
    font-weight: bold;
    margin-right: 0.01em;
}

li {}

.container-module {
    text-align: left;

    p {
        margin: 0;
        padding: 0;
    }

    img {
        width: 80px;
        display: inline-block;
        vertical-align: middle;
    }

    .modulo-name {
        display: inline-block;
        vertical-align: middle;
        width: 80%;
        text-align: left;
        padding-left: 10px;
    }

    @media screen and (max-width: 500px) {
        text-align: center;

        img {
            width: 40%;
        }

        .modulo-name {
            width: 100%;
            padding-left: 0px;
        }
    }
}

.pantalla {
    @media screen and (max-width: 600px) {
        display: none;
    }
}

.mobile {
    @media screen and (min-width: 600px) {
        display: none;
    }

    @media screen and (max-width: 600px) {
        display: block;
    }
}
</style>